// extracted by mini-css-extract-plugin
module.exports = {"container":"helperSearch_container__2QUj6"};